/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import KebabMenu from '../../../../KebabMenu';
import classes from './styles.module.scss';
import { JobsContext } from '../../../../../context/JobsContext';

export default function ClientFeedbacks({ jobApplication, job, refetch }) {
  const { showFeedbackModal } = useContext(JobsContext);

  const { t } = useTranslation();

  const handleClickOnFeedback = (
    interview,
    isReviewing = false,
    existingFeedback = null,
    readOnly = false
  ) => {
    showFeedbackModal({
      candidate: jobApplication,
      interview,
      job,
      refetch,
      isReviewing,
      existingFeedback,
      readOnly,
    });
  };

  const sharedFeedbacks = jobApplication?.jobApplicationInterviews?.flatMap(
    (interview) =>
      interview.jobApplicationInterviewFeedbacks.filter(
        (feedback) => feedback.isShared
      )
  );

  return (
    <div className={classes.interviews}>
      <div className={classes.container}>
        <h2 className={classes.title}>
          {t(
            'dashboardComponents.Candidate.AssessmentAndInterview.Interview.Assessments'
          )}
        </h2>
      </div>
      {sharedFeedbacks?.length === 0 ? (
        <p className={classes.noData}>
          {t(
            'dashboardComponents.Candidate.AssessmentAndInterview.Interview.No assessments shared'
          )}
        </p>
      ) : (
        <>
          <div className={classes.interviewList}>
            {jobApplication?.jobApplicationInterviews
              .filter((interview) =>
                interview.jobApplicationInterviewFeedbacks.some(
                  (feedback) => feedback.isShared
                )
              )
              .sort(
                (a, b) => new Date(a.interviewDate) - new Date(b.interviewDate)
              )
              .map((interview) => {
                const sharedInterviewFeedbacks =
                  interview.jobApplicationInterviewFeedbacks.filter(
                    (feedback) => feedback.isShared
                  );

                return (
                  <div className={classes.interview} key={interview?.id}>
                    <div className={classes.lower}>
                      {sharedInterviewFeedbacks.length ? (
                        <div className={classes.lowerSection}>
                          <div className={classes.feedbackList}>
                            {sharedInterviewFeedbacks.map((feedback) => {
                              let feedbackTypeText = '';
                              if (feedback?.feedbackType === 'Internal') {
                                feedbackTypeText = 'Internal Feedback';
                              } else if (
                                feedback?.feedbackType === 'External'
                              ) {
                                feedbackTypeText = 'External Feedback';
                              } else if (
                                interview.companyManagers.some(
                                  (companyManager) =>
                                    companyManager.id === feedback.userId
                                )
                              ) {
                                feedbackTypeText = 'Client Feedback';
                              }

                              const interviewerName =
                                feedback?.user?.userProfile?.fullName ??
                                'Author Uknown';

                              let feedbackRecommendationTypeText = '';
                              if (
                                feedback.recommendationType === 'StrongHire'
                              ) {
                                feedbackRecommendationTypeText = 'Strong Hire';
                              } else if (
                                feedback.recommendationType === 'Hire'
                              ) {
                                feedbackRecommendationTypeText = 'Hire';
                              } else if (
                                feedback.recommendationType === 'Neutral'
                              ) {
                                feedbackRecommendationTypeText = 'Neutral';
                              } else if (
                                feedback.recommendationType === 'NotHire'
                              ) {
                                feedbackRecommendationTypeText = 'Not Hire';
                              } else {
                                feedbackRecommendationTypeText =
                                  'Not Specified';
                              }

                              return (
                                <div
                                  className={classes.feedback}
                                  key={feedback.id}
                                >
                                  <div className={classes.col}>
                                    <p className={classes.title}>
                                      {interviewerName}
                                    </p>
                                    <p
                                      className={classNames(
                                        classes.description,
                                        classes.muted
                                      )}
                                    >
                                      {feedbackTypeText}
                                    </p>
                                  </div>
                                  <div className={classes.col}>
                                    <p className={classes.title}>
                                      {feedback.feedbackRating}
                                    </p>
                                    <p
                                      className={classNames(
                                        classes.description,
                                        classes.muted
                                      )}
                                    >
                                      {t(
                                        'dashboardComponents.Candidate.AssessmentAndInterview.Interview.Rating'
                                      )}
                                    </p>
                                  </div>
                                  <div className={classes.col}>
                                    <p className={classes.title}>
                                      {feedbackRecommendationTypeText}
                                    </p>
                                    <p
                                      className={classNames(
                                        classes.description,
                                        classes.muted
                                      )}
                                    >
                                      {t(
                                        'dashboardComponents.Candidate.AssessmentAndInterview.Interview.Recommendation Type'
                                      )}
                                    </p>
                                  </div>
                                  <div className={classes.col}>
                                    <p className={classes.title}>
                                      {feedback.reviewedAt
                                        ? t('common.reviewed')
                                        : t('common.notReviewed')}
                                    </p>
                                    <p
                                      className={classNames(
                                        classes.description,
                                        classes.muted
                                      )}
                                    >
                                      {t(
                                        'dashboardComponents.Candidate.AssessmentAndInterview.Interview.status'
                                      )}
                                    </p>
                                  </div>

                                  <div className={classes.col}>
                                    <KebabMenu
                                      variant="small"
                                      options={[
                                        {
                                          label: t('common.viewFeedback'),
                                          value: 'viewFeedback',

                                          onClick: () => {
                                            handleClickOnFeedback(
                                              interview,
                                              true,
                                              feedback,
                                              true
                                            );
                                          },
                                        },
                                      ]}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
}
